import React, { useRef } from "react";
import PropTypes from "prop-types";
import "./PDFUploader.css";

function PDFUploader({ onProcess, loading }) {
  const inputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "application/pdf") {
      onProcess({ error: "Please upload a valid PDF file." });
      return;
    }
    onProcess(file);
    inputRef.current.value = "";
  };

  return (
    <div className="uploader-container">
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        disabled={loading}
      />
      {loading && <span className="loading">Processing...</span>}
    </div>
  );
}

PDFUploader.propTypes = {
  onProcess: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default PDFUploader;
